import { getStore } from '../store/store';

export default function getIsCopilotThemeSelected(): boolean {
    return getStore().options.isSelected;
}
